import Slider from './components/Slider';
import './styles.scss';
export default Slider;
